import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import ax from "../config"
import { openNotification } from "src/components/helpers/notification"
import { message } from "antd"

const initialState = {
  abonementsList: null,
  abonementsListLoading: false,
  abonementsClubsList: null,
  abonementsClubsListLoading: false,
  abonementClubsItems: null,
  abonementClubsItemsLoading: null,
  abonementListClubServices: null,
  abonementListClubServicesLoading: false,
  abonemetsTypes: null,
  abonementClubs: null,
  abonementServices: null,
  abonementCurrentClub: null,
  AbonementStructureLoading: false,
  abonementStructure: null,
}

export const getAbonementsList = createAsyncThunk(
  "getAbonementsList",
  async (payload, { dispatch }) => {
    try {
      dispatch(setAbonementsListLoading(true))
      const { data } = await ax.get("/api/admin/abonements/getAbonements", {
        params: payload,
      })
      data && dispatch(setAbonementsListLoading(false))
      return data
    } catch (error) {
      error && dispatch(setAbonementsListLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const getAbonementsListClubs = createAsyncThunk(
  "getAbonementsListClubs",
  async (payload, { dispatch }) => {
    try {
      dispatch(setAbonementsClubsListLoading(true))
      const { data } = await ax.get("/api/admin/abonements/getAbonementClubs", {
        params: payload,
      })
      data && dispatch(setAbonementsClubsListLoading(false))
      return data
    } catch (error) {
      error && dispatch(setAbonementsClubsListLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const getAbonementsListClubsById = createAsyncThunk(
  "getAbonementsListClubsById",
  async (id, { dispatch }) => {
    try {
      dispatch(setAbonementsClubsListLoading(true))
      const { data } = await ax.get(
        `/api/admin/abonements/getAbonementClubs/${id}`
      )
      data && dispatch(setAbonementsClubsListLoading(false))
      return data
    } catch (error) {
      error && dispatch(setAbonementsClubsListLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const getAbonementListClubItems = createAsyncThunk(
  "getAbonementListClubItems",
  async (payload, { dispatch }) => {
    try {
      dispatch(setAbonementClubsItemsLoading(true))
      const { data } = await ax.get(
        "/api/admin/abonements/getAbonementClubItems",
        { params: payload }
      )
      data && dispatch(setAbonementClubsItemsLoading(false))
      return data
    } catch (error) {
      error && dispatch(setAbonementClubsItemsLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const getAbonementListClubServices = createAsyncThunk(
  "getAbonementListClubServices",
  async (payload, { dispatch }) => {
    try {
      dispatch(setAbonementListClubServices(true))
      const { data } = await ax.get(
        "/api/admin/abonements/getAbonementClubServices",
        { params: payload }
      )
      data && dispatch(setAbonementListClubServices(false))
      return data
    } catch (error) {
      error && dispatch(setAbonementListClubServices(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const getAbonementTypes = createAsyncThunk(
  "getAbonementTypes",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.get("/api/admin/getAbonementTypes", {
        params: payload,
      })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const addAbonement = createAsyncThunk(
  "addAbonement",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.put(
        "/api/admin/abonements/addAbonement",
        payload
      )
      data &&
        openNotification({
          type: "success",
          message: `Абонемент успешно добавлен`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const getClubs = createAsyncThunk(
  "getClubs",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.get("/api/admin/getClubs", { params: payload })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const addAbonementClub = createAsyncThunk(
  "addAbonementClub",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.put(
        "/api/admin/abonements/addAbonementClub",
        payload
      )
      data &&
        openNotification({
          type: "success",
          message: `Стоимость пакета успешно добавлена`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const getServices = createAsyncThunk(
  "getServices",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.get("/api/admin/getServices", {
        params: payload,
      })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const addAbonementClubItem = createAsyncThunk(
  "addAbonementClubItem",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.put(
        "/api/admin/abonements/addAbonementClubItem",
        payload
      )
      data &&
        openNotification({
          type: "success",
          message: `Состав пакета успешно добавлен`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const addAbonementClubService = createAsyncThunk(
  "addAbonementClubService",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.put(
        "/api/admin/abonements/addAbonementClubService",
        payload
      )
      data &&
        openNotification({
          type: "success",
          message: `Услуга успешно добавлена`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const deleteAbonement = createAsyncThunk(
  "deleteAbonement",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.post(
        "/api/admin/abonements/deleteAbonement",
        payload
      )
      data &&
        openNotification({
          type: "success",
          message: `Абонемент успешно удален`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const deleteAbonementClub = createAsyncThunk(
  "deleteAbonementClub",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.post(
        "/api/admin/abonements/deleteAbonementClub",
        payload
      )
      data &&
        openNotification({
          type: "success",
          message: `Стоимость пакета успешно удалена`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const deleteClubItem = createAsyncThunk(
  "deleteClubItem",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.post(
        "/api/admin/abonements/deleteClubItem",
        payload
      )
      data &&
        openNotification({
          type: "success",
          message: `Состав пакета успешно удален`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const deleteClubService = createAsyncThunk(
  "deleteClubService",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.post(
        "/api/admin/abonements/deleteClubService",
        payload
      )
      data &&
        openNotification({
          type: "success",
          message: `Услуга успешно удалена`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const editAbonement = createAsyncThunk(
  "editAbonement",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.post(
        "/api/admin/abonements/editAbonement",
        payload
      )
      data &&
        openNotification({
          type: "success",
          message: `Абонемент успешно отредактирован`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const editAbonementClub = createAsyncThunk(
  "editAbonementClub",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.post(
        "/api/admin/abonements/editAbonementClub",
        payload
      )
      data &&
        openNotification({
          type: "success",
          message: `Изменения успешно сохранены`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const editClubItem = createAsyncThunk(
  "editClubItem",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.post(
        "/api/admin/abonements/editClubItem",
        payload
      )
      data &&
        openNotification({
          type: "success",
          message: `Состав пакета успешно отредактирован`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const editClubService = createAsyncThunk(
  "editClubService",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.post(
        "/api/admin/abonements/editClubService",
        payload
      )
      data &&
        openNotification({
          type: "success",
          message: `Услуга успешно отредактирована`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const editOrderAbonementClubs = createAsyncThunk(
  "editOrderAbonementClubs",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.post(
        "/api/admin/abonements/editOrderAbonementClubs",
        payload
      )
      data &&
        openNotification({
          type: "success",
          message: `Порядок успешно отредактирован`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const AbonementStructure = createAsyncThunk(
  "abonements/getAbonementItems",
  async (payload) => {
    try {
      const data = await ax.get("/api/admin/abonements/getAbonementItems", {
        params: payload,
      })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const addAbonementStructure = createAsyncThunk(
  "abonements/addAbonementItems",
  async (payload) => {
    try {
      const data = await ax.post("/api/admin/abonements/addAbonementItems", payload)
      data &
        openNotification({
          type: "success",
          message: "Состав абонемента успешно добавлен"
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const editAbonementStructure = createAsyncThunk(
  "abonements/editAbonementItems",
  async (payload) => {
    try {
      const data = await ax.put("/api/admin/abonements/editAbonementItems", payload)
      data &
        openNotification({
          type: "success",
          message: "Состав абонемента успешно изменён"
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const deleteAbonementStructure = createAsyncThunk(
    "abonements/deleteAbonementItems",
  async (payload) => {
    try {
      const data = await ax.delete("/api/admin/abonements/deleteAbonementItems", {
        params: payload
    })
      data &
        openNotification({
          type: "success",
          message: "Состав абонемента успешно удалён"
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

const AbonementsSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {
    setAbonementsListLoading: (state, action) => {
      state.abonementsListLoading = action.payload
    },
    setAbonementsClubsListLoading: (state, action) => {
      state.abonementsClubsListLoading = action.payload
    },
    setAbonementClubsItemsLoading: (state, action) => {
      state.abonementClubsItemsLoading = action.payload
    },
    setAbonementListClubServices: (state, action) => {
      state.abonementListClubServicesLoading = action.payload
    },
    setAbonementStructureLoading: (state, action) => {
      state.AbonementStructureLoading = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAbonementsList.fulfilled, (state, action) => {
      state.abonementsList = action.payload
    }),
      builder.addCase(getAbonementsListClubs.fulfilled, (state, action) => {
        state.abonementsClubsList = action.payload
      }),
      builder.addCase(getAbonementsListClubsById.fulfilled, (state, action) => {
        state.abonementCurrentClub = action.payload
      }),
      builder.addCase(getAbonementListClubItems.fulfilled, (state, action) => {
        state.abonementClubsItems = action.payload
      }),
      builder.addCase(
        getAbonementListClubServices.fulfilled,
        (state, action) => {
          state.abonementListClubServices = action.payload
        }
      ),
      builder.addCase(getAbonementTypes.fulfilled, (state, action) => {
        state.abonemetsTypes = action.payload
      }),
      builder.addCase(getClubs.fulfilled, (state, action) => {
        state.abonementClubs = action.payload
      }),
      builder.addCase(getServices.fulfilled, (state, action) => {
        state.abonementServices = action.payload
      }),
      builder.addCase(AbonementStructure.pending, (state) => {
        state.AbonementStructureLoading = true
      }),
      builder.addCase(AbonementStructure.fulfilled, (state, action) => {
        state.AbonementStructureLoading = false
        state.abonementStructure = action.payload
      }),
      builder.addCase(AbonementStructure.rejected, (state) => {
        state.AbonementStructureLoading = false
      })
  },
})

export const {
  setAbonementsListLoading,
  setAbonementsClubsListLoading,
  setAbonementClubsItemsLoading,
  setAbonementListClubServices,
} = AbonementsSlice.actions

export default AbonementsSlice.reducer
